import { THREE } from 'expo-three';
import React, { useMemo } from 'react';

const getShape = (
  width: number,
  height: number,
  cornerRadius: number = 0,
  bender = 0 // brings the control point a bit inner to give a more curved look
  // eslint-disable-next-line max-params
) => {
  const hasRadius = cornerRadius > 0;
  const radius = cornerRadius;

  const shape = new THREE.Shape();
  const { x, y } = { x: -width / 2, y: -height / 2 };
  shape.moveTo(x, y + radius);
  shape.lineTo(x, y + height - radius);
  // topLeft corner
  hasRadius &&
    shape.quadraticCurveTo(
      x + bender,
      y + height - bender,
      x + radius,
      y + height
    );
  shape.lineTo(x + width - radius, y + height);
  // topRight corner
  hasRadius &&
    shape.quadraticCurveTo(
      x + width - bender,
      y + height - bender,
      x + width,
      y + height - radius
    );
  shape.lineTo(x + width, y + radius);
  // bottomRight corner
  hasRadius &&
    shape.quadraticCurveTo(
      x + width - bender,
      y + bender,
      x + width - radius,
      y
    );
  shape.lineTo(x + radius, y);
  // bottomLeft corner
  hasRadius && shape.quadraticCurveTo(x + bender, y + bender, x, y + radius);

  return shape;
};

type Props = {
  width: number;
  height: number;
  radius: number;
  bender?: number;
};

export const RoundedRectangleGeometry = ({
  width,
  height,
  radius,
  bender,
}: Props) => {
  const shape = useMemo(
    () => getShape(width, height, radius, bender),
    [width, height, radius]
  );

  return <shapeBufferGeometry attach='geometry' args={[shape]} />;
};

export const getRoundedRectangleShape = getShape;
